import { Component, inject, LOCALE_ID } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import { CorporateDesignService } from './shared/services/corporate-design.service';

registerLocaleData(localeDe);

@Component({
  selector: 'ez-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  providers: [{ provide: LOCALE_ID, useValue: 'de-DE' }],
})
export class AppComponent {
  private corporateDesignService = inject(CorporateDesignService);
  // CorporateDesignService is injected to initiate its effect to update the design

  constructor() {
    document.fonts?.load('16px "Material Symbols Outlined"').then(() => {
      this.corporateDesignService.setMaterialSymbolsLoaded(true);
    });
  }
}
